import * as React from 'react';
import styled from 'styled-components';
import { useContractContext, useFeatures, useModalSettingsContext } from 'src/providers';

import { ReactComponent as CloseX } from 'src/images/close-x.svg';

const StyledWrapper = styled.div<{ highVisibility: boolean }>`
  button {
    position: absolute;
    top: 11px;
    right: 7px;
    height: 44px;
    width: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--medium-gray);
    cursor: pointer;
    z-index: 10;

    ${({ highVisibility }) => highVisibility && `
      // For better visibility with modal-brand-image experiment. See ModalBrandImage.tsx
      @media (min-width: 1000px) {
        border-radius: 50%;
        background: var(--lightest-gray);
      }
    `}

    &:focus, &:hover {
      color: var(--black);
    }

    &:focus {
      outline: none;
      outline-style: none;
      box-shadow: none;
      border-color: transparent;
    }
  }
`;

interface ICloseButtonProps {
  dummy?: string; // Doesn't really use props but is needed for ForwardedRef
}

const Button = (props: ICloseButtonProps, ref: React.ForwardedRef<HTMLButtonElement>) => {
  const { declineProtection } = useContractContext();
  const { showModalBrandImage } = useFeatures();
  const { modalType } = useModalSettingsContext();

  const highVisibility = React.useMemo(() => (showModalBrandImage || false), [showModalBrandImage]);

  return (
    <StyledWrapper highVisibility={highVisibility}>
      <button
        aria-label="close"
        className="button-reset"
        id="close-btn"
        onClick={() => declineProtection('close-x', modalType)}
        ref={ref}
      >
        <CloseX />
      </button>
    </StyledWrapper>
  );
};

export const CloseButton = React.forwardRef(Button);
